// retoursMobileShared.js — helpers de l'écran « Retour d'achat » mobile.

const ROOT = "Gestion Commerciale.Approvisionnement.Achats.RetourAchat";
export const PERM = {
  view: `${ROOT}.view`,
  create: `${ROOT}.create`,
  edit: `${ROOT}.edit`,
  delete: `${ROOT}.delete`,
};

// GestionRetourAchat.tsx:65-66
export const QUANTITY_DECIMALS = 5;
export const MIN_RETURN_QUANTITY = 0.00001;

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

/** Saisie décimale tolérante (virgule française, espaces). */
export const parseDecimal = (v) => {
  const n = Number(String(v ?? "").replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const paymentPill = (status) => {
  const s = String(status || "Non payé");
  if (s === "Payé") return { tone: "ok", label: "Payé" };
  if (s === "Partiel" || s === "Partiellement payé") return { tone: "warn", label: "Partiel" };
  return { tone: "danger", label: "Non payé" };
};

export const orderPill = (record) => {
  const s = String(record.order_status || "En attente");
  if (s === "Annulé") return { tone: "danger", label: s };
  if (s === "En attente") return { tone: "draft", label: s };
  return { tone: "ok", label: s };
};

/**
 * Actions destructives — la logique du retour d'achat DIFFÈRE de celle des achats
 * (GestionRetourAchat.tsx:3411-3463) : « supprimer » et « annuler » coexistent, et une
 * commande déjà annulée n'offre plus aucune action.
 * Renvoie { restore, cancel, delete } — booléens.
 */
export const destructiveActionsFor = (record, canDelete) => {
  if (!canDelete) return { restore: false, cancel: false, delete: false };
  if (record.is_deleted === 1) return { restore: true, cancel: false, delete: false };
  if (record.order_status === "Annulé") return { restore: false, cancel: false, delete: false };
  return { restore: false, cancel: true, delete: Boolean(record.is_deletable) };
};

/** handleEdit refuse l'édition dans ces cas (l.3266-3272 + colonne l.3425). */
export const isEditBlocked = (record) =>
  record.order_status === "Annulé" ||
  record.is_deleted === 1 ||
  !record.is_deletable ||
  num(record.paid_amount) > 0;

/**
 * Totaux — formules exactes du desktop (handleUpdateProduct l.2208-2212 et le
 * useEffect de totaux l.2305-2358). Fonction pure : `globalTax` (ou null) écrase
 * le taux de toutes les lignes lorsqu'il est fourni.
 */
export const computeTotals = (lines, globalTax) => {
  let subTotal = 0;
  let discountAmount = 0;
  let taxAmount = 0;

  const computed = lines.map((line) => {
    const gross = num(line.unit_price) * num(line.quantity);
    const lineDiscount = (gross * num(line.discount_rate)) / 100;
    const taxable = gross - lineDiscount;
    const rate = globalTax ? num(globalTax.rate) : num(line.tax_rate);
    const lineTax = (taxable * rate) / 100;

    subTotal += taxable;
    discountAmount += lineDiscount;
    if (!globalTax) taxAmount += lineTax;

    return { ...line, tax_rate: rate, tax_amount: lineTax, subtotal: taxable + lineTax };
  });

  if (globalTax) taxAmount = (subTotal * num(globalTax.rate)) / 100;

  return { lines: computed, subTotal, discountAmount, taxAmount, grandTotal: subTotal + taxAmount };
};

/** Statut de paiement dérivé (comme calculatePaymentStatus du desktop). */
export const paymentStatusOf = (paid, total) => {
  if (num(paid) <= 0) return "Non payé";
  if (num(paid) >= num(total)) return "Payé";
  return "Partiellement payé";
};
